import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, Input } from '@mono/ui-components';
import { Check, Copy, Info } from 'lucide-react';
import { useEffect, useState } from 'react';
import { toast } from 'sonner';
/**
 * Minimal share UX for v1. Copies the editor URL to the clipboard; access is
 * tenant-scoped on the backend so "anyone in your workspace who has the link"
 * maps exactly to shirohige's current access check. Per-user roles and
 * public/restricted share links land in v2 along with Cerbos policies.
 */ export function ShareDialog({ open, onOpenChange, documentId, documentName }) {
    const shareUrl = typeof window !== 'undefined' ? `${window.location.origin}/editor/${documentId}` : '';
    const [copied, setCopied] = useState(false);
    useEffect(()=>{
        if (copied) {
            const t = setTimeout(()=>setCopied(false), 1500);
            return ()=>clearTimeout(t);
        }
    }, [
        copied
    ]);
    async function handleCopy() {
        try {
            await navigator.clipboard.writeText(shareUrl);
            setCopied(true);
            toast.success('Link copied');
        } catch  {
            toast.error("Couldn't copy — you can copy it manually");
        }
    }
    return /*#__PURE__*/ _jsx(Dialog, {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ _jsxs(DialogContent, {
            className: "sm:max-w-lg",
            children: [
                /*#__PURE__*/ _jsxs(DialogHeader, {
                    children: [
                        /*#__PURE__*/ _jsxs(DialogTitle, {
                            children: [
                                "Share “",
                                documentName,
                                "”"
                            ]
                        }),
                        /*#__PURE__*/ _jsx(DialogDescription, {
                            children: "Anyone in your workspace with this link can open and co-edit the document."
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ _jsx(Input, {
                            readOnly: true,
                            value: shareUrl,
                            onFocus: (e)=>e.currentTarget.select()
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            onClick: handleCopy,
                            variant: "secondary",
                            children: copied ? /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(Check, {
                                        className: "w-4 h-4 mr-1"
                                    }),
                                    " Copied"
                                ]
                            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(Copy, {
                                        className: "w-4 h-4 mr-1"
                                    }),
                                    " Copy"
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-start gap-2 text-xs text-muted-foreground rounded-md bg-muted/40 p-3",
                    children: [
                        /*#__PURE__*/ _jsx(Info, {
                            className: "w-4 h-4 shrink-0 mt-0.5"
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            children: "Per-person access and public share links are coming — v1 uses workspace-wide sharing."
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(DialogFooter, {
                    children: /*#__PURE__*/ _jsx(Button, {
                        variant: "outline",
                        onClick: ()=>onOpenChange(false),
                        children: "Done"
                    })
                })
            ]
        })
    });
}
